import { render, staticRenderFns } from "./Bans.vue?vue&type=template&id=a131f0d4&"
import script from "./Bans.vue?vue&type=script&lang=ts&"
export * from "./Bans.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports